module.exports = __webpack_public_path__ + "img/diagnosis.fd8cb90f.png";